"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BAnnouncementNegative", {
  enumerable: true,
  get: function get() {
    return _BAnnouncementNegative["default"];
  }
});
Object.defineProperty(exports, "BAnnouncementPositive", {
  enumerable: true,
  get: function get() {
    return _BAnnouncementPositive["default"];
  }
});
Object.defineProperty(exports, "BCashRecieveNegative", {
  enumerable: true,
  get: function get() {
    return _BCashRecieveNegative["default"];
  }
});
Object.defineProperty(exports, "BCashRecievePositive", {
  enumerable: true,
  get: function get() {
    return _BCashRecievePositive["default"];
  }
});
Object.defineProperty(exports, "BCellphoneNegative", {
  enumerable: true,
  get: function get() {
    return _BCellphoneNegative["default"];
  }
});
Object.defineProperty(exports, "BCellphonePositive", {
  enumerable: true,
  get: function get() {
    return _BCellphonePositive["default"];
  }
});
Object.defineProperty(exports, "BCertificateNegative", {
  enumerable: true,
  get: function get() {
    return _BCertificateNegative["default"];
  }
});
Object.defineProperty(exports, "BCertificatePositive", {
  enumerable: true,
  get: function get() {
    return _BCertificatePositive["default"];
  }
});
Object.defineProperty(exports, "BComputerNegative", {
  enumerable: true,
  get: function get() {
    return _BComputerNegative["default"];
  }
});
Object.defineProperty(exports, "BComputerPositive", {
  enumerable: true,
  get: function get() {
    return _BComputerPositive["default"];
  }
});
Object.defineProperty(exports, "BDaysNegative", {
  enumerable: true,
  get: function get() {
    return _BDaysNegative["default"];
  }
});
Object.defineProperty(exports, "BDaysPositive", {
  enumerable: true,
  get: function get() {
    return _BDaysPositive["default"];
  }
});
Object.defineProperty(exports, "BErrorNegative", {
  enumerable: true,
  get: function get() {
    return _BErrorNegative["default"];
  }
});
Object.defineProperty(exports, "BErrorPositive", {
  enumerable: true,
  get: function get() {
    return _BErrorPositive["default"];
  }
});
Object.defineProperty(exports, "BEstimatedTimeNegative", {
  enumerable: true,
  get: function get() {
    return _BEstimatedTimeNegative["default"];
  }
});
Object.defineProperty(exports, "BEstimatedTimePositive", {
  enumerable: true,
  get: function get() {
    return _BEstimatedTimePositive["default"];
  }
});
Object.defineProperty(exports, "BFastNegative", {
  enumerable: true,
  get: function get() {
    return _BFastNegative["default"];
  }
});
Object.defineProperty(exports, "BFastPositive", {
  enumerable: true,
  get: function get() {
    return _BFastPositive["default"];
  }
});
Object.defineProperty(exports, "BInterestNegative", {
  enumerable: true,
  get: function get() {
    return _BInterestNegative["default"];
  }
});
Object.defineProperty(exports, "BInterestPositive", {
  enumerable: true,
  get: function get() {
    return _BInterestPositive["default"];
  }
});
Object.defineProperty(exports, "BLicensePlateNegative", {
  enumerable: true,
  get: function get() {
    return _BLicensePlateNegative["default"];
  }
});
Object.defineProperty(exports, "BLicensePlatePositive", {
  enumerable: true,
  get: function get() {
    return _BLicensePlatePositive["default"];
  }
});
Object.defineProperty(exports, "BLongerTermNegative", {
  enumerable: true,
  get: function get() {
    return _BLongerTermNegative["default"];
  }
});
Object.defineProperty(exports, "BLongerTermPositive", {
  enumerable: true,
  get: function get() {
    return _BLongerTermPositive["default"];
  }
});
Object.defineProperty(exports, "BLowerInterestNegative", {
  enumerable: true,
  get: function get() {
    return _BLowerInterestNegative["default"];
  }
});
Object.defineProperty(exports, "BLowerInterestPositive", {
  enumerable: true,
  get: function get() {
    return _BLowerInterestPositive["default"];
  }
});
Object.defineProperty(exports, "BOneClickNegative", {
  enumerable: true,
  get: function get() {
    return _BOneClickNegative["default"];
  }
});
Object.defineProperty(exports, "BOneClickPositive", {
  enumerable: true,
  get: function get() {
    return _BOneClickPositive["default"];
  }
});
Object.defineProperty(exports, "BPartnersNegative", {
  enumerable: true,
  get: function get() {
    return _BPartnersNegative["default"];
  }
});
Object.defineProperty(exports, "BPartnersPositive", {
  enumerable: true,
  get: function get() {
    return _BPartnersPositive["default"];
  }
});
Object.defineProperty(exports, "BPartnershipNegative", {
  enumerable: true,
  get: function get() {
    return _BPartnershipNegative["default"];
  }
});
Object.defineProperty(exports, "BPartnershipPositive", {
  enumerable: true,
  get: function get() {
    return _BPartnershipPositive["default"];
  }
});
Object.defineProperty(exports, "BPioneersNegative", {
  enumerable: true,
  get: function get() {
    return _BPioneersNegative["default"];
  }
});
Object.defineProperty(exports, "BPioneersPositive", {
  enumerable: true,
  get: function get() {
    return _BPioneersPositive["default"];
  }
});
Object.defineProperty(exports, "BPressNegative", {
  enumerable: true,
  get: function get() {
    return _BPressNegative["default"];
  }
});
Object.defineProperty(exports, "BPressPositive", {
  enumerable: true,
  get: function get() {
    return _BPressPositive["default"];
  }
});
Object.defineProperty(exports, "BSearchNegative", {
  enumerable: true,
  get: function get() {
    return _BSearchNegative["default"];
  }
});
Object.defineProperty(exports, "BSearchPositive", {
  enumerable: true,
  get: function get() {
    return _BSearchPositive["default"];
  }
});
Object.defineProperty(exports, "BSmallestInstallmentNegative", {
  enumerable: true,
  get: function get() {
    return _BSmallestInstallmentNegative["default"];
  }
});
Object.defineProperty(exports, "BSmallestInstallmentPositive", {
  enumerable: true,
  get: function get() {
    return _BSmallestInstallmentPositive["default"];
  }
});
Object.defineProperty(exports, "BSuccessNegative", {
  enumerable: true,
  get: function get() {
    return _BSuccessNegative["default"];
  }
});
Object.defineProperty(exports, "BSuccessPositive", {
  enumerable: true,
  get: function get() {
    return _BSuccessPositive["default"];
  }
});
Object.defineProperty(exports, "BSuggestionNegative", {
  enumerable: true,
  get: function get() {
    return _BSuggestionNegative["default"];
  }
});
Object.defineProperty(exports, "BSuggestionPositive", {
  enumerable: true,
  get: function get() {
    return _BSuggestionPositive["default"];
  }
});
Object.defineProperty(exports, "BTimeNegative", {
  enumerable: true,
  get: function get() {
    return _BTimeNegative["default"];
  }
});
Object.defineProperty(exports, "BTimePositive", {
  enumerable: true,
  get: function get() {
    return _BTimePositive["default"];
  }
});

var _BAnnouncementNegative = _interopRequireDefault(require("./BAnnouncementNegative"));

var _BAnnouncementPositive = _interopRequireDefault(require("./BAnnouncementPositive"));

var _BCashRecieveNegative = _interopRequireDefault(require("./BCashRecieveNegative"));

var _BCashRecievePositive = _interopRequireDefault(require("./BCashRecievePositive"));

var _BCellphoneNegative = _interopRequireDefault(require("./BCellphoneNegative"));

var _BCellphonePositive = _interopRequireDefault(require("./BCellphonePositive"));

var _BCertificateNegative = _interopRequireDefault(require("./BCertificateNegative"));

var _BCertificatePositive = _interopRequireDefault(require("./BCertificatePositive"));

var _BComputerNegative = _interopRequireDefault(require("./BComputerNegative"));

var _BComputerPositive = _interopRequireDefault(require("./BComputerPositive"));

var _BDaysNegative = _interopRequireDefault(require("./BDaysNegative"));

var _BDaysPositive = _interopRequireDefault(require("./BDaysPositive"));

var _BErrorNegative = _interopRequireDefault(require("./BErrorNegative"));

var _BErrorPositive = _interopRequireDefault(require("./BErrorPositive"));

var _BEstimatedTimeNegative = _interopRequireDefault(require("./BEstimatedTimeNegative"));

var _BEstimatedTimePositive = _interopRequireDefault(require("./BEstimatedTimePositive"));

var _BFastNegative = _interopRequireDefault(require("./BFastNegative"));

var _BFastPositive = _interopRequireDefault(require("./BFastPositive"));

var _BInterestNegative = _interopRequireDefault(require("./BInterestNegative"));

var _BInterestPositive = _interopRequireDefault(require("./BInterestPositive"));

var _BLicensePlateNegative = _interopRequireDefault(require("./BLicensePlateNegative"));

var _BLicensePlatePositive = _interopRequireDefault(require("./BLicensePlatePositive"));

var _BLongerTermNegative = _interopRequireDefault(require("./BLongerTermNegative"));

var _BLongerTermPositive = _interopRequireDefault(require("./BLongerTermPositive"));

var _BLowerInterestNegative = _interopRequireDefault(require("./BLowerInterestNegative"));

var _BLowerInterestPositive = _interopRequireDefault(require("./BLowerInterestPositive"));

var _BOneClickNegative = _interopRequireDefault(require("./BOneClickNegative"));

var _BOneClickPositive = _interopRequireDefault(require("./BOneClickPositive"));

var _BPartnersNegative = _interopRequireDefault(require("./BPartnersNegative"));

var _BPartnersPositive = _interopRequireDefault(require("./BPartnersPositive"));

var _BPartnershipNegative = _interopRequireDefault(require("./BPartnershipNegative"));

var _BPartnershipPositive = _interopRequireDefault(require("./BPartnershipPositive"));

var _BPioneersNegative = _interopRequireDefault(require("./BPioneersNegative"));

var _BPioneersPositive = _interopRequireDefault(require("./BPioneersPositive"));

var _BPressNegative = _interopRequireDefault(require("./BPressNegative"));

var _BPressPositive = _interopRequireDefault(require("./BPressPositive"));

var _BSearchNegative = _interopRequireDefault(require("./BSearchNegative"));

var _BSearchPositive = _interopRequireDefault(require("./BSearchPositive"));

var _BSmallestInstallmentNegative = _interopRequireDefault(require("./BSmallestInstallmentNegative"));

var _BSmallestInstallmentPositive = _interopRequireDefault(require("./BSmallestInstallmentPositive"));

var _BSuccessNegative = _interopRequireDefault(require("./BSuccessNegative"));

var _BSuccessPositive = _interopRequireDefault(require("./BSuccessPositive"));

var _BSuggestionNegative = _interopRequireDefault(require("./BSuggestionNegative"));

var _BSuggestionPositive = _interopRequireDefault(require("./BSuggestionPositive"));

var _BTimeNegative = _interopRequireDefault(require("./BTimeNegative"));

var _BTimePositive = _interopRequireDefault(require("./BTimePositive"));